module.exports = __webpack_public_path__ + "img/source_gf-03.1a1682b4.png";